import axios from 'axios';
import api from './api';

const API_BASE_URL = (process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000').trim().replace(/\/$/, '');

const form = (text, files) => {
  const fd = new FormData();
  fd.append('text', text || '');
  (files || []).forEach((f) => fd.append('files', f));
  return fd;
};

// Team side
export const yarnsAPI = {
  list: (params) => api.get('/api/yarns', { params }),
  unreadCount: () => api.get('/api/yarns/unread-count'),
  create: (data) => api.post('/api/yarns', data),
  get: (id) => api.get(`/api/yarns/${id}`),
  update: (id, data) => api.patch(`/api/yarns/${id}`, data),
  remove: (id) => api.delete(`/api/yarns/${id}`),
  post: (id, text, files) => api.post(`/api/yarns/${id}/posts`, form(text, files), { headers: { 'Content-Type': 'multipart/form-data' } }),
  file: (id, fileId) => api.get(`/api/yarns/${id}/files/${fileId}`, { responseType: 'blob' }),
  addGuest: (id, guest) => api.post(`/api/yarns/${id}/guests`, guest),
  resendGuest: (id, gid) => api.post(`/api/yarns/${id}/guests/${gid}/resend`),
  guestLink: (id, gid) => api.get(`/api/yarns/${id}/guests/${gid}/link`),
  removeGuest: (id, gid) => api.delete(`/api/yarns/${id}/guests/${gid}`),
};

// Client side (secure link, no login)
const pub = axios.create({ baseURL: API_BASE_URL });
export const yarnPublicAPI = {
  get: (token) => pub.get(`/api/yarn-public/${token}`),
  post: (token, text, files) => pub.post(`/api/yarn-public/${token}/posts`, form(text, files)),
  fileUrl: (token, fileId) => `${API_BASE_URL}/api/yarn-public/${token}/files/${fileId}`,
};
